import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_URL = "https://wa.me/5561981660749";

export function WhatsAppButton() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fale pelo WhatsApp"
            className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
        >
            {/* Tooltip */}
            <span className="pointer-events-none translate-x-2 scale-95 opacity-0 transition-all duration-200 group-hover:translate-x-0 group-hover:scale-100 group-hover:opacity-100 rounded-full bg-white dark:bg-[#1a1a1a] border border-slate-200 dark:border-white/10 px-3 py-1.5 text-sm font-medium text-slate-900 dark:text-white shadow-lg whitespace-nowrap">
                Fale pelo WhatsApp
            </span>

            {/* Button with pulse ring */}
            <span className="relative flex items-center justify-center">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30" />
                <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_4px_24px_rgba(37,211,102,0.4)] transition-transform duration-200 hover:scale-110">
                    <FaWhatsapp className="h-7 w-7 text-white" />
                </span>
            </span>
        </a>
    );
}
